import blockquote, { blockquoteVariants } from './blockquote';

const quote = {
  blockquote
};

export const quoteVariants = {
  blockquote: blockquoteVariants
};
export default quote;
